// extracted by mini-css-extract-plugin
export default {"meals":"Menu_meals__lrM83","meals-appear":"Menu_meals-appear__6UvXn"};